import { render, staticRenderFns } from "./puertaAutomatica.vue?vue&type=template&id=3d4b51d6&scoped=true&"
import script from "./puertaAutomatica.vue?vue&type=script&lang=js&"
export * from "./puertaAutomatica.vue?vue&type=script&lang=js&"
import style0 from "./puertaAutomatica.vue?vue&type=style&index=0&id=3d4b51d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b51d6",
  null
  
)

export default component.exports